import { render, staticRenderFns } from "./SystemSettings.vue?vue&type=template&id=a80d5d14&scoped=true"
import script from "./SystemSettings.vue?vue&type=script&lang=js"
export * from "./SystemSettings.vue?vue&type=script&lang=js"
import style0 from "./SystemSettings.vue?vue&type=style&index=0&id=a80d5d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80d5d14",
  null
  
)

export default component.exports